module.exports = __webpack_public_path__ + "img/settings.99d3c049.svg";